module.exports = __webpack_public_path__ + "img/Inflammation-ASHN_GSE227469.dd240dc3.png";